import React from 'react'
import Students from '../component/Profile/Students'

export default function AllStudents() {
  return (
    <>
    <Students />
    </>
  )
}
